exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".register-container[data-v-6682a64b]{border-radius:5px;-moz-border-radius:5px;background-clip:padding-box;margin:180px auto;width:350px;padding:35px 35px 15px;background:#fff;border:1px solid #eaeaea;box-shadow:0 0 10px #cac6c6;z-index:99;.title{margin:0 auto 40px;color:#505458}.remember{margin:0 0 35px}}.el-row[data-v-6682a64b]{margin-bottom:20px}.el-col[data-v-6682a64b]{border-radius:4px}.bg-purple-dark[data-v-6682a64b]{background:#99a9bf}.bg-purple[data-v-6682a64b]{border:1px solid #f3f3f3;padding:10px;box-sizing:border-box}.grid-content[data-v-6682a64b]{border-radius:4px;min-height:770px}.row-bg[data-v-6682a64b]{padding:10px 0;background-color:#f9fafc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6682a64b","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/components/SystemConfigure.vue
// module id = 251
// module chunks = 0